/*
 * � 2020 Microsoft. All rights reserved.
 */

define('util/ScaleParams',[], function () {
	var ScaleParams = {
		slideOutMenu: {
			widthBreakPoint: 640
		},
		menuBar: {
			menuButton: {
				x: 0,
				width: 81,
				height: 66
			},
			backButton: {
				width: 81,
				height: 66,
				x: 110
			},
			fullScreenButton: {
				offsetX: 0,
				width: 81,
				height: 66
			},
			newsButton: {
				y: 3
			},
			widthBreakPoint: 741,
			pageLabelHidePoint: 560
		},
		gameScreenUI: {
			fontSize: 33,
			labelsY: 18,
			icon: {
				x: 200,
				y: 0.1
			},
			gameLabel: {
				offsetX: 5,
				y: 17
			},
			boardsCompleteLabelX: 1050,
			timeLabelX: 200,
			timeX: 1160,
			boardsCompleteOffsetX: 30,
			dealLabelFontSize: 25,
			gameNumberLabel: {
				x: 1639,
				y: 15
			},
			gameNumber: {
				x: 1750,
				y: 15
			}
		}
	};
	return ScaleParams;
});

